export const _pptMimeTypes = [
  "application/mspowerpoint",
  "application/vnd.ms-powerpoint",
  'application/vnd.ms-powerpoint; version="4.0"',
  'application/vnd.ms-powerpoint; version="95"',
  'application/vnd.ms-powerpoint; version="97-2003"',
  'application/vnd.ms-powerpoint; version="4.0"',
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
];
